import { observeRequest } from 'libraries/front-end-core/helpers/api'

const fcObserveRequest = observeRequest({ forbiddenAllowed: true })

export default fcObserveRequest
